import { render, staticRenderFns } from "./offershelp.vue?vue&type=template&id=54c98dbe&"
import script from "./offershelp.vue?vue&type=script&lang=js&"
export * from "./offershelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('54c98dbe')) {
      api.createRecord('54c98dbe', component.options)
    } else {
      api.reload('54c98dbe', component.options)
    }
    module.hot.accept("./offershelp.vue?vue&type=template&id=54c98dbe&", function () {
      api.rerender('54c98dbe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2XmXlExkjPaSs/JS/offershelp.vue"
export default component.exports